export default __webpack_public_path__ + "static/media/step3.488f9e0e.png";